import { supabase } from '@/integrations/supabase/client';

import { createSimpleCRUDEntity } from '../crud-factory';

// Translation Entity (simple, no transformations)
export const Translation = createSimpleCRUDEntity('translations', {
  customMethods: {
    // Alias for get method (some code uses .read())
    read: async (id: string | number) => {
      const { data, error } = await supabase
        .from('translations')
        .select('*')
        .eq('id', String(id))
        .single();
      if (error) throw error;
      return data;
    },
  },
});
